import React, { useState, useEffect } from 'react';
import { subscriptionsAPI, productsAPI } from '../services/api';

function SubscriptionsPage() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [formData, setFormData] = useState({
    product_id: '',
    quantity: 1,
    frequency: 'monthly',
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [subsRes, prodsRes] = await Promise.all([
        subscriptionsAPI.getAll(),
        productsAPI.getAll(),
      ]);
      setSubscriptions(subsRes.data);
      setProducts(prodsRes.data);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await subscriptionsAPI.create(formData);
      setShowCreateForm(false);
      setFormData({ product_id: '', quantity: 1, frequency: 'monthly' });
      loadData();
    } catch (error) {
      alert('Error creating subscription');
    }
  };

  const handlePause = async (id) => {
    try {
      await subscriptionsAPI.pause(id);
      loadData();
    } catch (error) {
      alert('Error pausing subscription');
    }
  };

  const handleResume = async (id) => {
    try {
      await subscriptionsAPI.resume(id);
      loadData();
    } catch (error) {
      alert('Error resuming subscription');
    }
  };

  const handleCancel = async (id) => {
    if (!window.confirm('Are you sure you want to cancel this subscription?')) return;
    try {
      await subscriptionsAPI.cancel(id);
      loadData();
    } catch (error) {
      alert('Error canceling subscription');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="page">
      <h1 className="page-title">My Subscriptions</h1>

      <button
        onClick={() => setShowCreateForm(!showCreateForm)}
        className="btn btn-primary"
        style={{ marginBottom: '20px' }}
      >
        {showCreateForm ? 'Cancel' : 'Create New Subscription'}
      </button>

      {showCreateForm && (
        <div className="card">
          <h3>Create Subscription</h3>
          <form onSubmit={handleCreate}>
            <div className="form-group">
              <label>Product</label>
              <select
                value={formData.product_id}
                onChange={(e) => setFormData({ ...formData, product_id: e.target.value })}
                required
              >
                <option value="">Select a product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name} - ${product.price_per_bag}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Quantity (bags)</label>
              <input
                type="number"
                min="1"
                value={formData.quantity}
                onChange={(e) => setFormData({ ...formData, quantity: parseInt(e.target.value) })}
                required
              />
            </div>

            <div className="form-group">
              <label>Frequency</label>
              <select
                value={formData.frequency}
                onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                required
              >
                <option value="weekly">Weekly</option>
                <option value="biweekly">Bi-weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>

            <button type="submit" className="btn btn-success">
              Create Subscription
            </button>
          </form>
        </div>
      )}

      {subscriptions.length === 0 ? (
        <div className="card">
          <p>No subscriptions yet</p>
        </div>
      ) : (
        <div className="subscriptions-list">
          {subscriptions.map((sub) => (
            <div key={sub.id} className="card">
              <div className="order-header">
                <h3>{sub.product?.name}</h3>
                <span className={`status-badge status-${sub.status}`}>
                  {sub.status}
                </span>
              </div>

              <p><strong>Quantity:</strong> {sub.quantity} bags</p>
              <p><strong>Frequency:</strong> {sub.frequency}</p>
              <p><strong>Next Delivery:</strong> {new Date(sub.next_delivery_date).toLocaleDateString()}</p>

              <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                {sub.status === 'active' && (
                  <button onClick={() => handlePause(sub.id)} className="btn btn-secondary">
                    Pause
                  </button>
                )}
                {sub.status === 'paused' && (
                  <button onClick={() => handleResume(sub.id)} className="btn btn-success">
                    Resume
                  </button>
                )}
                {sub.status !== 'cancelled' && (
                  <button onClick={() => handleCancel(sub.id)} className="btn btn-danger">
                    Cancel
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SubscriptionsPage;
